import { useTranslation } from 'react-i18next';
import styles from './Pagination.module.css';

interface Props {
  page: number; // 0-indexed
  totalPages: number;
  totalItems: number;
  size: number;
  onPage: (p: number) => void;
}

export function Pagination({ page, totalPages, totalItems, size, onPage }: Props) {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;
  const from = page * size + 1;
  const to = Math.min((page + 1) * size, totalItems);

  return (
    <div className={styles.root}>
      <span className={styles.count}>
        {t('ui.pagination.range', { from, to, total: totalItems })}
      </span>
      <div className={styles.controls}>
        <button
          className={styles.btn}
          disabled={page === 0}
          onClick={() => onPage(page - 1)}
          aria-label={t('ui.pagination.previous')}
        >
          ‹
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={i === page ? `${styles.btn} ${styles.active}` : styles.btn}
            onClick={() => onPage(i)}
            aria-current={i === page ? 'page' : undefined}
          >
            {i + 1}
          </button>
        ))}
        <button
          className={styles.btn}
          disabled={page === totalPages - 1}
          onClick={() => onPage(page + 1)}
          aria-label={t('ui.pagination.next')}
        >
          ›
        </button>
      </div>
    </div>
  );
}
